/**
 * What a call card says about moving itself: a sentence with a hole in it where
 * the word that acts goes. Lowercase and clause-shaped because none of them
 * stands alone — each is welded onto the card's standing line after an em dash.
 */
interface MoveLine {
  before: string;
  /** The word that acts, rendered as the only control in the line. */
  action: string;
  /** Carries its own leading space when the sentence continues past the action. */
  after: string;
  label: string;
}

/** While there is still time — the deadline itself, which is the useful half of
    the 24-hour rule to someone looking at a call three weeks out. */
export const callMoveOpen = (deadline: string): MoveLine => ({
  before: 'you can',
  action: 'move it',
  after: ` free until ${deadline}.`,
  label: 'Move this call to another time',
});

/** The same line while the picker is open — the action is the way back out. */
export const CALL_MOVE_PICKING: MoveLine = {
  before: 'pick a new time below, or',
  action: 'keep this one',
  after: '.',
  label: 'Keep this call at its current time',
};

/** Once the window has closed there is nothing to act on, so this one is plain
    text. The stake rides along — the only place a client is told a missed call
    costs them the call. */
export const CALL_MOVE_CLOSED = 'too late to move, a missed call spends it.';

/** The server's no to a picked hour — taken, moved onto, or past the notice
    window; the picker cannot tell which, and one honest sentence covers all. */
export const SLOT_GONE = 'That time just went. Pick another one.';

/** The deadline leads as an action because the header's "expires" doesn't say
    what the date governs: it is BOOKING that must happen inside the window —
    an unbooked call is the thing that expires. */
export const passFinePrint = (expires: string): string =>
  `Book before ${expires}. This purchase isn't refundable.`;
